import type {
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import { list } from 'src/app/common/classes/request-builder';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class TrazabilidadListsDefinition {

    public proveedores: DropdownData<Compradores> = list<Compradores>(['...', null]);

    public fincas: DropdownData<FincasModel> = list<FincasModel>(['...', null]);

    public sectores: DropdownData<SectorModel> = list<SectorModel>(['...', null]);

    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>(['...', null]);

    public cultivos: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);

    public variedades: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);

    public incidencias: DropdownData<string> = list<string>(
        ['...', null],
        'Frío',
        'Caída Cajas',
        'Plagas',
        'Otros Problemas'
    );

    public formatos: DropdownData<string> = list<string>(
        ['...', null],
        'ARB,10,5',
        'MIX 14',
        'MIX 17',
        'T/BI 19',
        'T/27',
        'TRIO 15',
        'PYR/23',
        'VISMART',
        'TRIO 13'
    );
}